import { makeAutoObservable, extendObservable, action } from 'mobx';
import { isSuperAdmin } from 'helpers/usersRolesHelper';
import domainData from 'store/domainStore';
import tableOptions from 'pages/campaigns/config/config';
import { getInitialParams, saveParamsToStorage } from './common/filterUtils';

const currentUser = domainData.getCurrentUser();
const isUserSuperAdmin = isSuperAdmin(currentUser);

const STORAGE_KEY = 'campaigns_filter_params';

// Default filter parameters
const defaultFilterParams = {
  params: {
    sort: {
      field: 'createdAt',
      order: 'desc',
    },
    filter: {},
    limit: 50,
    skip: 0,
    search: {
      value: '',
      fields: [],
    },
  },
};

class CampaignsStore {
  getDefaultStoreProps = () => ({
    filterData: defaultFilterParams,
  });

  constructor() {
    makeAutoObservable(this);
    extendObservable(this, { ...this.getDefaultStoreProps() });
  }

  // Get current filter parameters using common utility with validation
  getCurrentFilterParams = (urlParams = {}) => {
    const subscriptionAccess = domainData.getSubscriptionAllAccess();
    const userContext = { isUserSuperAdmin, subscriptionAccess };
    return getInitialParams(STORAGE_KEY, defaultFilterParams, tableOptions.campaigns, userContext, urlParams);
  };

  @action
  setFilter(filter) {
    this.filterData = filter;
    // Save to localStorage using common utility, but exclude search
    if (filter?.params) {
      const { search: _search, ...paramsWithoutSearch } = filter.params;
      const filterToSave = {
        ...filter,
        params: paramsWithoutSearch,
      };
      saveParamsToStorage(STORAGE_KEY, filterToSave);
    }
  }
}

export default new CampaignsStore();
